module.exports = __webpack_public_path__ + "img/empty.5199a07a.svg";